<arm-side-nav [items]="networkServicesItems" [title]="'Network Services'" class="settings"></arm-side-nav>
